"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageBrowseBase = exports.ImageBrowse = void 0;
var _core = require("@emotion/core");
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
var _i18n = require("../../../i18n/i18n");
var _useTheme = require("../../../theme/utils/useTheme");
var _button = require("../../button");
var _HiddenInputStyled = require("../styled/HiddenInputStyled");
var _imageUploaderTheme = require("../styled/imageUploaderTheme");
const ImageBrowseBase = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    accept,
    browseButtonTextId = "Browse",
    buttonAppearance = "borderless",
    buttonSize = "normal",
    clientId,
    i18n,
    isDisabled,
    onChange,
    onOpenBrowser,
    onCloseBrowser
  } = _ref;
  const inputElement = (0, _react.useRef)(null);
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const handleClickBrowse = event => {
    event.stopPropagation();
    inputElement.current?.click();
    onOpenBrowser?.();
  };
  const handleChange = event => {
    const file = event.target.files?.[0];
    if (!file) return;
    onChange(file);
  };
  const handleFocusBack = (0, _react.useCallback)(() => {
    window.removeEventListener("focus", handleFocusBack);
    onCloseBrowser?.();
  }, [onCloseBrowser]);
  const handleClickInput = () => {
    window.addEventListener("focus", handleFocusBack);
  };
  (0, _react.useEffect)(() => {
    return () => {
      window.removeEventListener("focus", handleFocusBack);
    };
  }, [handleFocusBack]);
  const isChangeButton = browseButtonTextId === "Change";
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.ClassNames, null, _ref2 => {
    let {
      cx,
      css
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_button.Button, {
      ref: ref,
      appearance: buttonAppearance,
      clientId: (0, _lodestarUtils.getClientId)(clientId, "browse"),
      isDisabled: isDisabled,
      onClick: handleClickBrowse,
      className: cx(buttonAppearance === "borderless" && css`
                                        font-weight: ${_imageUploaderTheme.imageUploaderTheme.browseButton.fontWeight(themeMode)};
                                    `, buttonSize === "small" && css`
                                        // this is because the Rrsa button is smaller when it's "Browse
                                        // and same as Lodestar when it's "Change"
                                        height: ${isChangeButton ? 32 : _imageUploaderTheme.imageUploaderTheme.browseButton.height(themeMode)}px;
                                        font-size: ${_imageUploaderTheme.imageUploaderTheme.browseButton.fontSize(themeMode)}px;
                                    `),
      type: "button"
    }, browseButtonTextId === "Browse" && i18n._( /*i18n*/"Browse"), browseButtonTextId === "Change" && i18n._( /*i18n*/"Change"));
  }), /*#__PURE__*/_react.default.createElement(_HiddenInputStyled.HiddenInputStyled, {
    ref: inputElement,
    type: "file",
    accept: accept,
    onClick: handleClickInput,
    onChange: handleChange,
    "data-client-id": (0, _lodestarUtils.getClientId)(clientId, "input")
  }));
});
exports.ImageBrowseBase = ImageBrowseBase;
ImageBrowseBase.displayName = "ImageBrowse";
const ImageBrowse = (0, _i18n.withI18n)(ImageBrowseBase);
exports.ImageBrowse = ImageBrowse;
//# sourceMappingURL=ImageBrowse.js.map